<kort [id]="invitasjon().id">
  <div class="kontainer">
    <gruppe-logo [gruppe]="null" stil="stor"/>
    <div class="informasjon">

      <h2 class="tittel" data-testid="tittel">{{ invitasjon().gruppeTittel }}</h2>
      <p class="organisasjonsnavn" data-testid="organisasjonsnavn">{{ invitasjon().gruppeOrganisasjonsnavn }}</p>
      <p class="meta">
        {{ 'Som'|translate }} {{ rolleTittel() }}, invitert {{ invitasjon().opprettetDato | zoneddatetimeSomPlaindate |plaindate }}
      </p>
    </div>
  </div>
  <kort-handlinger>
    <button mat-button type="button" color="primary" (click)="godta()" data-testid="godta">
      <mat-icon fontSet="ion-ios-checkmark-empty" class="mat-icon--ionic-ikon"/>
      {{ "Godta"|translate }}
    </button>
    <button mat-button type="button" color="warn" (click)="avslaa()" data-testid="avslå">
      <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
      {{ "Avslå"|translate }}
    </button>
  </kort-handlinger>
</kort>

